import React from "react";
import cns from "classnames";
import locale from "@bonliva-crm/locale";
import { Button, makeStyles } from "@material-ui/core";
import { useUserProfile } from "@hooks";
import { useFormField } from "@clientUtils";

export function SetUserResponsiblePersonButton() {
  const classes = useStyles();

  const {
    field: { value },
    setFieldValue
  } = useFormField<string[]>("responsiblePerson");
  const user = useUserProfile();
  const userProfileId = user.myProfile._id;

  const selected = value?.length === 1 && value[0] === userProfileId;

  function onClick() {
    setFieldValue(selected ? [] : [userProfileId]);
  }

  return (
    <div>
      <Button
        onClick={onClick}
        variant="outlined"
        className={cns({
          [classes.buttonSelected]: selected
        })}
      >
        {locale.mine}
      </Button>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  buttonSelected: {
    backgroundColor: theme.palette.grey["300"]
  }
}));
